import type * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'
import cn from 'classnames'
import { Icon } from '../icon'
import styles from './Switch.module.css'

export interface SwitchProps extends React.ComponentPropsWithRef<typeof SwitchPrimitives.Root> {
  className?: string
}

function Switch({ ref, className, ...props }: SwitchProps) {
  return (
    <SwitchPrimitives.Root
      className={cn(styles.wrapper, className)}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb className={styles.thumb}>
        <Icon className={styles.icon} glyph="CheckMarkExtraSmall" />
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  )
}

export default Switch
